import React from 'react'

const DeleteTag = (props) => (
    <svg width="10" height="9" viewBox="0 0 10 9"
         xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.44088 2.79928L5.12758 4.49998M5.12758 4.49998L6.94187 2.70063M5.12758 4.49998L3.31329 6.29933M5.12758 4.49998L6.81428 6.20068"
            stroke={props ? props.color : '#FFFFFF'} strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)

export default DeleteTag
